export const splitImages = () => {
    const imageContainers = document.querySelectorAll('[data-split-images]');
    imageContainers.forEach((container) => {
        if (container.getAttribute('data-split-images-fill') == 'true') {
            const setContainerWidth = () => {
                const layout = container.getAttribute('data-split-images-position');
                const viewportOffset = container.getBoundingClientRect();
                if (layout == 'left') {
                    const distanctFromLeft = viewportOffset.left + viewportOffset.width;
                    container.style.setProperty('--container-width', distanctFromLeft + 'px');
                }
                else {
                    const pageWidth = document.body.offsetWidth;
                    const distanctFromLeft = viewportOffset.left;
                    const containerWidth = pageWidth - distanctFromLeft;
                    container.style.setProperty('--container-width', containerWidth + 'px');
                }
            };
            const events = ['load', 'resize'];
            events.forEach((event) => {
                window.addEventListener(event, () => {
                    setContainerWidth();
                });
            });
        }
    });
};
